/**
 * Tara Edition — motion layer.
 * Smooth scroll (Lenis) + scroll-triggered reveals (GSAP/ScrollTrigger),
 * layered on top of Horizon without touching cart/checkout logic.
 * Fully inert under prefers-reduced-motion.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    var sections = document.querySelectorAll('#MainContent > .shopify-section, main .shopify-section');

    if (reduceMotion || !window.gsap || !window.ScrollTrigger) {
      // No motion library, or user prefers none: show everything, do nothing else.
      sections.forEach(function (el) { el.style.opacity = 1; });
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Smooth scroll
    var lenis = null;
    if (window.Lenis) {
      lenis = new Lenis({
        duration: 1.1,
        easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        smoothWheel: true,
      });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
      window.__taraLenis = lenis;
    }

    // Section-level reveal: fade + rise, once, batched for performance.
    sections.forEach(function (el) {
      if (el.closest('#header-group') || el.closest('[id*="footer-group"]') || el.tagName === 'FOOTER') return;
      gsap.fromTo(
        el,
        { autoAlpha: 0, y: 32 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 88%',
            once: true,
          },
        }
      );
    });

    // Explicit opt-in reveal for finer-grained elements (thesis lines, cards, etc.)
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      gsap.fromTo(
        el,
        { autoAlpha: 0, y: 24 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 90%', once: true },
        }
      );
    });

    // Marquee strip: continuous linear scroll, paused on hover, driven by GSAP so it
    // stays in sync with Lenis rather than relying on a raw CSS keyframe drift.
    document.querySelectorAll('[data-marquee]').forEach(function (track) {
      var inner = track.querySelector('[data-marquee-track]');
      if (!inner) return;
      var tween = gsap.to(inner, {
        xPercent: -50,
        repeat: -1,
        duration: parseFloat(track.dataset.marqueeSpeed || '28'),
        ease: 'none',
      });
      track.addEventListener('mouseenter', function () { tween.timeScale(0.15); });
      track.addEventListener('mouseleave', function () { tween.timeScale(1); });
    });
  });
})();
